// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const InfoIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M7.925 18.731c.928-2.939 2.681-6.46 2.991-7.35.45-1.292-.346-1.866-2.857.344L7.5 10.674c2.865-3.117 8.764-3.822 6.756 1.006-1.253 3.015-2.15 5.05-2.662 6.62-.748 2.289 1.14 1.361 2.987-.346.252.411.334.544.585 1.017-4.103 3.907-8.659 4.25-7.241-.24zm7.79-13.42c-.874.745-2.169.729-2.892-.036-.725-.763-.603-1.984.268-2.728.875-.745 2.17-.726 2.894.037.721.765.603 1.985-.27 2.727z"/></svg>'} />;

InfoIcon.displayName = 'InfoIcon';

export default InfoIcon;
